<app-control-wrapper [control]="fc" [errors]="errors" [helper]="helper">
  <div control-wrapper class="number-block">
    <label [for]="id" *ngIf="label">
      {{ label | translate }}
      <ng-template [ngIf]="tooltipData">
        <app-hint-tooltip-icon [hint]="tooltipData | translate"></app-hint-tooltip-icon>
      </ng-template>
    </label>
    <input
      type="text"
      [formControl]="fc"
      class="form-control"
      [id]="id"
      [name]="id"
      inputmode="numeric"
      autocomplete="on"
      [placeholder]="placeholder"
      [mask]="mask"
      [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS'"
      [maxMaskLength]="maxLength"
    />
    <ng-container *ngIf="validationLoading">
      <span class="ng-spinner-loader" [ngClass]="{ 'has-label': !!label }"></span>
    </ng-container>
  </div>
</app-control-wrapper>
